export default "__VITE_ASSET__fbf83107__"